import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { isEmpty, map, noop } from 'lodash';
import ListForm from '../../../components/ListForm/ListForm.component';
import ContentTable from '../../../components/ContentTable/ContentTable.component';
import { commaFormatted, normalizeAmount } from '../../../utils/transformer.util';
import { KELOLA_PEMBAGIAN_KELASKHUSUS_FORM_FIELDS  } from '../../../constants/Akademi/DataKelas/kelas.constant';
import { PEMBAGIAN_KELASKHUSUS_TABLE_FIELDS  } from '../../../constants/Akademi/DataKelas/kelas.constant';
import { Button, Select, Input } from '../../../components/base';
import KelolaPembagianKlsKhususTable from '././components/KelolaPembagianKlsKhususTable.component';

export default class PembagianKelasKhusus extends Component {
  constructor(props) {
    super(props);
    this._onFormChange = this._onFormChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this._onDeleteList = this._onDeleteList.bind(this);

    //this.deletepelajaran = this.deletepelajaran.bind(this);
    //this._onAddList = this._onAddList.bind(this);
    this._onClickAdd = this._onClickAdd.bind(this);
    
    this.state = {
      form: {
        value: {
          pelajaran: [
            {
              Matpel: '',
              Kelas:'',
               //divisi: '',
              nominal: 0,
            }                                      
          ],
        },
        error: {
          pelajaran: '',

        },
      },
      
    };
  }

  componentDidMount(){
    const{handleGetClasses } = this.props
    handleGetClasses();
  }

  // on formchange untuk form
  _onFormChange(event) {
    const {
      name,
      value,
      dataset,
      checked,
      type,
    } = event.target;
    const {
      inputType = 'text', inputArray = false, arrayPosition = 0,
      fieldName,
    } = dataset;
    this.setState((prevState) => {
      let newList = [];
      let newListError = [];
      let formattedValue = value;

      if (inputType === 'number') {
        formattedValue = normalizeAmount(value);
      }
      if (inputArray) {
        if (type === 'checkbox') {
          formattedValue = checked;
        }
        newList = prevState.form.value[fieldName];
        newListError = prevState.form.error[fieldName];
        newList[arrayPosition][name] = formattedValue;
        if (name === 'code_of_account') {
          newList[arrayPosition].isCredit = value.type;
        }
        if (!isEmpty(newListError[arrayPosition])) {
          newListError[arrayPosition][name] = '';
        }
      }
      return {
        form: {
          value: {
            ...prevState.form.value,
            ...(inputArray
              ? { [fieldName]: newList }
              : { [name]: formattedValue }),
          },
          error: {
            ...prevState.form.error,
            ...(inputArray
              ? { [fieldName]: newListError }
              : { [name]: '' }),
          },
        },
      };
    });
  }

  _onClickAdd(data) {
    const { form } = this.state;
    const { pelajaran } = form.value;
    
    pelajaran.push({
      Kelas: '',
      Matpel:'',
      // divisi: '',
      nominal: 0,
      //period:'',
    });
    
    this.setState(prevState => ({
      form: {
        value: {
          ...prevState.form.value,
          pelajaran,
        },
        error: {
          ...prevState.form.error,
        }
      }
    }));
    console.log(pelajaran)
  }

  _onDeleteList(idx) {
    this.setState((prevState) => {
      const { pelajaran } = prevState.form.value;
      const list = prevState.form.value.pelajaran;

      list.splice(idx, 1);
      return {
        ...prevState,
        pelajaran: list
      };
    });
  }

  // on formchange untuk tabel
  onFormChange(event) {
    const {
      name,
      value,
      dataset,
    } = event.target;
    console.log(name)
    const { inputArray = false, arrayPosition = 0, inputType = 'text' } = dataset;
    this.setState((prevState) => {
      let formattedValue = value;
      let newpelajaran = [];
      if (inputType === 'number') {
        formattedValue = normalizeAmount(value);
      }

      if (inputArray) {
        newpelajaran = prevState.form.value.pelajaran;
        newpelajaran[arrayPosition][name] = value;
      }
      return {
        form: {
          value: {
            ...prevState.form.value,
            ...(inputArray ? 
              { pelajaran: newpelajaran } : 
              { [name]: formattedValue }
            )
          },
          error: {
            ...prevState.form.error,
            form:'',
            [name]: '',
          },
        },
      };
    });
  }

  onSubmit(e) {
    e.preventDefault();
    // const { form} = this.state;
    const { form } = this.state;
    const { handleAddBudget, history, user } = this.props;
    const { workingUnit, prm_school_units_id } = user;

    let unit_id = prm_school_units_id;

    if (unit_id === null && workingUnit && workingUnit.id) {
      unit_id = workingUnit.id;
    }
    handleAddBudget(form.value, history.goBack, unit_id);
    // handleAddBudget(form.value, pelajaran, history.goBack, unit_id);
    //handleAddBudget(form.value, history.goBack, unit_id);
  }

  deletepelajaran(e) {
    var array = [...this.state.people]; // make a separate copy of the array
    var index = array.indexOf(e.target.value)
    if (index !== -1) {
      array.splice(index, 1);
      this.setState({people: array});
    }
  }

  render() {
    const { form } = this.state;
    const { value } = form;
    const { classes={}, handleGetKelas } = this.props;
    const {pelajaran} = form.value;
    return (
      <div className="add-budget">
        <div className="budget__title">
        <h1>Pembagian Kelas Khusus</h1>
        <hr></hr>
        </div>
        
        <form onSubmit={this.onSubmit}>
        {/* <ListForm
            form={form}
            formFields={KELOLA_PEMBAGIAN_KELASKHUSUS_FORM_FIELDS}
            onFormChange={this._onFormChange}
          /> */}

        <div className="manage-registration__custom-form-row">
              <div className="manage-registration__custom-form-row__field">
              <Input
                name="classes"
                disabled
                label="Kelas"
                onChange={this._onFormChange}
                placeholder="Pilihan"
                data={classes.list}
                value={value.classes}
              />
              </div>
              <div className="manage-registration__custom-form-row__field">
                  <Input
                      type="text"
                      name="wali_kelas"
                      label="Wali Kelas"
                      onChange={this._onFormChange}
                      value={form.value.wali_kelas || ''}
                      error={form.error.wali_kelas || ''}
                  />
              </div>
          </div>

           <div className="budget__content">
          <label style={{fontSize:14}}>Daftar Siswa</label>
          <KelolaPembagianKlsKhususTable
            form={form}
            onFormChange={this._onFormChange}
          />
          {/* <ContentTable
            onSearchContent={handleGetKelas}
            tableFields={PEMBAGIAN_KELASKHUSUS_TABLE_FIELDS}
          /> */}
        </div>
          <div className="add-budget">
            <Button
              type="submit"
              title="SIMPAN"
            />
          </div>
        </form>
      </div>
    );
  }

    //   render() {
    //     return (
    //         <ul>
    //             {this.props.items.map(item => (
    //                 <li key={item.id}>{item.text}<button onClick={this._handleDelete.bind(this, item.id)}>Delete</button></li>
    //             ))}
    //         </ul>
    //     );
    // } 
}
PembagianKelasKhusus.propTypes = {
  handleAddBudget: PropTypes.func,
  history: PropTypes.object.isRequired,
  user: PropTypes.object,
};
PembagianKelasKhusus.defaultProps = {
  handleAddBudget: noop,
  user: null,
};
